import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './lang/en'
import cnLocale from './lang/cn'
import hkLocale from './lang/hk'
import ruLocale from './lang/ru'

Vue.use(VueI18n)

const messages = {
  en_us: {
    ...enLocale
  },
  zh_cn: {
    ...cnLocale
  },
  zh_tw: {
    ...hkLocale
  },
  ru: {
    ...ruLocale
  }
}

const i18n = new VueI18n({
  locale: 'zh_tw',
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/index.js